export default __webpack_public_path__ + "static/media/sportplatzgarage.e748d180.svg";